export class ItemIdReq{
    itemId:number;
    unitId:number;
    locationId?:number;
}